import React, { useContext } from "react";
import { useLocation } from "react-router-dom";

import PartnerInvestorTableView from "./sub/PartnerInvestorTableView";
import PartnerRecommendPolicyView from "./sub/PartnerRecommendPolicyView";
import TrackAssignmentPhView from "./sub/TrackAssignmentPhView";
import PartnerReferView from "./sub/PartnerReferView";
import PartnerPHTableView from "./sub/PartnerPHTableView";
import { PartnerContext } from "./PartnerOutlet";
import PartnerReferredPortoflio from "./sub/PartnerReferredPortoflio";
import TrackAssignmentInvView from "./sub/TrackAssignmentInvView";

export default function PartnerDashboard() {
  const partnerContext = useContext(PartnerContext);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const view = queryParams.get("view");

  const ViewSwitcher = () => {
    switch (view) {
      case null:
        return partnerContext.viewMode === "INVESTOR" ? (
          <PartnerInvestorTableView />
        ) : (
          <PartnerPHTableView />
        );
      case "recommend-policy":
        return <PartnerRecommendPolicyView />;
      case "referred-portfolio":
        return <PartnerReferredPortoflio />;
      case "track-assignment":
        return partnerContext.viewMode === "INVESTOR" ? (
          <TrackAssignmentInvView />
        ) : (
          <TrackAssignmentPhView />
        );

      case "referred-user":
        return <PartnerReferView />;
      default:
        break;
    }
  };
  return <ViewSwitcher />;
}
